import type { ReactNode } from 'react';
import type { UseFormRegisterReturn } from 'react-hook-form';

export function TextField({
  label,
  error,
  registration,
  hint,
}: {
  label: string;
  error?: string;
  registration: UseFormRegisterReturn;
  hint?: string;
}) {
  return (
    <label className="flex flex-col gap-2 text-sm">
      <span>{label}</span>
      <input className="rounded-[var(--radius-sm)] border border-border bg-transparent px-3 py-2" {...registration} />
      {hint ? <span className="text-xs" style={{ color: 'var(--muted-foreground)' }}>{hint}</span> : null}
      {error ? <span className="text-xs" style={{ color: 'var(--danger)' }}>{error}</span> : null}
    </label>
  );
}

export function TextAreaField({
  label,
  error,
  registration,
  rows,
  hint,
}: {
  label: string;
  error?: string;
  registration: UseFormRegisterReturn;
  rows: number;
  hint?: string;
}) {
  return (
    <label className="flex flex-col gap-2 text-sm">
      <span>{label}</span>
      <textarea rows={rows} className="rounded-[var(--radius-sm)] border border-border bg-transparent px-3 py-2" {...registration} />
      {hint ? <span className="text-xs" style={{ color: 'var(--muted-foreground)' }}>{hint}</span> : null}
      {error ? <span className="text-xs" style={{ color: 'var(--danger)' }}>{error}</span> : null}
    </label>
  );
}

export function SelectField({
  label,
  error,
  registration,
  children,
}: {
  label: string;
  error?: string;
  registration: UseFormRegisterReturn;
  children: ReactNode;
}) {
  return (
    <label className="flex flex-col gap-2 text-sm">
      <span>{label}</span>
      <select className="rounded-[var(--radius-sm)] border border-border bg-transparent px-3 py-2" {...registration}>
        {children}
      </select>
      {error ? <span className="text-xs" style={{ color: 'var(--danger)' }}>{error}</span> : null}
    </label>
  );
}

export function ToggleField({
  label,
  registration,
}: {
  label: string;
  registration: UseFormRegisterReturn;
}) {
  return (
    <label className="flex items-center gap-2 text-sm pt-8">
      <input type="checkbox" {...registration} />
      <span>{label}</span>
    </label>
  );
}

export function JsonPreview({ title, value }: { title: string; value: unknown }) {
  return (
    <div className="flex flex-col gap-2">
      <span className="text-sm">{title}</span>
      <pre className="overflow-auto rounded-[var(--radius-sm)] border border-border p-3 text-xs" style={{ background: 'var(--bg-elevated)' }}>
        {JSON.stringify(value, null, 2)}
      </pre>
    </div>
  );
}
